define('specific/instagram/views/InstagramView', [
    'specific/instagram/templates/instagram',
    'components/factory/Factory',
    'components/stratemanager/StrateManager'
], function(tpl, Factory, StrateManager) {

    var Instagram = Mazarine.View.extend({

        events: {

        },

        template: tpl,

        className: "maz-instagram-view",

        $window: $( window ),

        initialize: function() {
            this.$window.on( 'scroll', _.bind( this.onScroll, this ) );
        },

        afterRender: function() {
            this.model.set('isReady', true);

            this.onScroll = this.onScroll.bind(this);
        },
        

        onScroll: function(e) {
            
        }
    });

    return Instagram;
});
